import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpUploadDocument} from '@/services/address.http'
import {MUTATION_KEYS} from '@/queryClient'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {errorHandler} from '@/utilities/helpers'
import {UploadedDocument} from '@/types'

export const useUploadDocument = (options?: UseMutationOptions<UploadedDocument, unknown, FormData>) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.UPLOAD_DOCUMENT],
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpUploadDocument(payload),
                responseShape: UploadedDocument,
                onZodError: captureException
            }),
        ...options,
        onError: (error, variables, context) => {
            errorHandler(error)
            options?.onError?.(error, variables, context)
        },
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
        }
    })
}
